import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  Container,
  Button,
  Table,
  Modal,
  ModalBody,
  Card,
  CardBody,
  Spinner,
  Row,
  Col,
} from "reactstrap";
import {
  acceptSportRequest,
  sportRequestDelete,
  getAllSportRequests,
} from "store/actions/sportRequestAction";
import { getAllUsers } from "store/actions/usersActions";
import TableComponent from "components/TableComponent";

import ConfirmationModal from "components/Modal/ConfirmationModal";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const RequestedSports = () => {
  let dispatch = useDispatch();
  const [modalPosition, setModalPosition] = useState(false);
  let { uid } = useSelector((state) => state.auth);
  let { allUsers } = useSelector((state) => state.users);
  let {
    sportRequestsData,
    lastDoc,
    hasMoreSportRequests,
    isFetchingSportRequests,
  } = useSelector((state) => state.requestSports);
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); //Modal For Show Position
  const [supporter, setSupporter] = useState();

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedSport, setSelectedSport] = useState(null);

  //Modal Position Toggle

  const handlePositionToggle = () => {
    setModalPosition(!modalPosition);
  };
  const [loader, setLoader] = useState({
    data: false,
  });

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getAllSportRequests(null, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);

  const handleLoadMore = () => {
    if (hasMoreSportRequests && !isFetchingSportRequests) {
      dispatch(getAllSportRequests(lastDoc));
    }
  };

  // GET ALL USERS

  useEffect(() => {
    if (allUsers.length == 0) {
      dispatch(getAllUsers());
    }
  }, []);

  const openAcceptConfirmation = (sport, detail, id) => {
    setSelectedSport({ sport, detail, id });
    setConfirmAction("accept");
    setConfirmModalOpen(true);
  };

  // Open confirm modal for reject action
  const openRejectConfirmation = (id) => {
    setSelectedSport({ id });
    setConfirmAction("reject");
    setConfirmModalOpen(true);
  };

  // Handle confirmation modal actions
  const handleConfirmAction = () => {
    setConfirmLoading(true);

    if (confirmAction === "accept" && selectedSport) {
      const { sport, detail, id } = selectedSport;
      let obj = {
        details: detail,
        sport: sport,
      };

      dispatch(
        acceptSportRequest(obj, id, () => {
          dispatch(getAllSportRequests(null));
          setConfirmLoading(false);
          setConfirmModalOpen(false);
          toast.success("Request accepted successfully");
        })
      );
    } else if (confirmAction === "reject" && selectedSport) {
      const { id } = selectedSport;

      dispatch(
        sportRequestDelete(id, () => {
          dispatch(getAllSportRequests(null));
          setConfirmLoading(false);
          setConfirmModalOpen(false);
          toast.success("Request rejected successfully");
        })
      );
    }
  };

  // PLAYER NAME FUNC

  const getPlayerName = (ID) => {
    var obj =
      allUsers &&
      allUsers.find((ele) => {
        return ele.id == ID;
      });
    if (obj) {
      if (obj.role == "athlete") {
        return obj.first_name + " " + obj.last_name;
      } else if (obj.role == "fan") {
        return obj.name;
      }
    } else {
      return "N/A";
    }
  };

  const handleSupportByName = (arr) => {
    setSupporter(arr);
    setIsModalOpen(true);
  };

  const handlePositionModal = (item) => {
    setModalPosition(true);
    setData(item);
  };

  const handleModal = () => {
    setIsModalOpen(false);
  };
  const deleteSportdata = (id) => {
    dispatch(
      sportRequestDelete(id, () => {
        dispatch(getAllSportRequests(null));
        toast.success("Request rejected successfully");
      })
    );
  };

  const columns = [
    "Sport",
    "My School's Name",
    "My School's Location",
    "Added By",
    "Support",
    "Support By",
    // "Actions"
  ];

  const keyMap = {
    Sport: "sport",
    "My School's Name": "college",
    "My School's Location": "location",
    "Added By": "added_by_name",
    Support: "supportDisplay",
    "Support By": "supportByIcon",
    // "Actions": "actions"
  };

  // Prepare data for the main table
  const preparedData = sportRequestsData.map((ele) => ({
    ...ele,
    location: `${ele.state}, ${ele.city}`,
    added_by_name: getPlayerName(ele.added_by),
    supportDisplay: (
      <div className="d-flex justify-content-center">
        <i className="fas fa-heart fa-2x text-danger"></i>
        <p className="pl-2">{ele.support}</p>
      </div>
    ),
    supportByIcon: (
      <i
        className="fas fa-eye fa-2x pointer"
        onClick={() => handleSupportByName(ele.supported_by)}
      ></i>
    ),
  }));

  const infoPoints = [
    "The admin can accept or reject sport requests submitted by athletes and fans. Additionally, the admin can track whether the request was initiated by an athlete or a fan.",
  ];
  const subPoints = [];
  const infoTitle = "Sports Request Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  // Action column renderer
  const renderActions = (row) => {
    if (row.status === "pending") {
      return (
        <>
          <Button
            size="sm"
            color="primary"
            onClick={() =>
              openAcceptConfirmation(row.sport, row.details, row.id)
            }
            // onClick={() =>
            //   handleAcceptSportRequest(
            //     row.sport,
            //     row.details,
            //     row.id
            //   )
            // }
          >
            Accept
          </Button>
          <Button
            size="sm"
            color="danger"
            onClick={() => openRejectConfirmation(row.id)}
          >
            Reject
          </Button>
        </>
      );
    } else {
      return row.status;
    }
  };

  // Sport details modal table configuration
  const detailColumns = ["Sport Category", "Category Name"];
  const detailKeyMap = {
    "Sport Category": "category",
    "Category Name": "meaning",
  };

  // Supporter modal table configuration
  const supporterColumns = ["Supporter Names"];
  const supporterKeyMap = {
    "Supporter Names": "name",
  };
  const supporterData = supporter?.map((id) => ({
    name: getPlayerName(id),
  }));

  return (
    <>
      <Header />
      <Container className="my-4" fluid>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        {loader.data ? (
          <div className="text-center mt-5">
            <Spinner color="primary" />
          </div>
        ) : sportRequestsData.length > 0 ? (
          <>
            <Card className="p-2">
              {/* <h2 className="px-3 mt-3">Sport Requests</h2> */}
              <Row>
                <Col sm="12">
                  {/* <Table
                    className="align-items-center table-flush mt-4"
                    responsive
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Sport
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading text-center"
                        >
                          My School’s Name
                        </th>

                        <th
                          scope="col"
                          className="custom-table-heading custom-heading text-center"
                        >
                          My School’s Location
                        </th>

                        <th
                          scope="col"
                          className="custom-table-heading custom-heading text-center"
                        >
                          Added By
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading text-center"
                        >
                          Support
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading text-center"
                        >
                          Support By
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading text-center"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="mt-3" style={{ background: "white" }}>
                      {sportRequestsData.length > 0 &&
                        sportRequestsData.map((ele, idx) => (
                          <tr>
                            <td
                              className={`custom-table-text ${
                                idx == 0 ? "custom-table-body-top-left" : ""
                              }`}
                            >
                              {ele.sport}
                            </td>
                            <td className="custom-table-text" align="center">
                              {ele.college}
                            </td>
                            <td className="custom-table-text" align="center">
                              {ele.state},{ele.city}
                            </td>

                            <td className="custom-table-text" align="center">
                              {getPlayerName(ele.added_by)}
                            </td>
                            <td align="center" className="custom-table-text">
                              <div className="d-flex justify-content-center">
                                <i className="fas fa-heart fa-2x text-danger"></i>
                                <p className="pl-2">{ele.support}</p>
                              </div>
                            </td>
                            <td className="custom-table-text" align="center">
                              <i
                                className="fas fa-eye fa-2x pointer"
                                onClick={() =>
                                  handleSupportByName(ele.supported_by)
                                }
                              ></i>
                            </td>
                            <td className="custom-table-text" align="center">
                              {ele.status === "pending" ? (
                                <>
                                  <Button
                                    size="sm"
                                    color="primary"
                                    onClick={() =>
                                      handleAcceptSportRequest(
                                        ele.sport,
                                        ele.details,
                                        ele.id
                                      )
                                    }
                                  >
                                    Accept
                                  </Button>
                                  <Button
                                    size="sm"
                                    color="danger"
                                    onClick={() => deleteSportdata(ele.id)}
                                  >
                                    Reject
                                  </Button>
                                </>
                              ) : (
                                ele.status
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table> */}
                  <TableComponent
                    columns={columns}
                    data={preparedData}
                    keyMap={keyMap}
                    renderActions={renderActions}
                  />
                  {sportRequestsData?.length > 4 && (
                    <div className="text-center py-4">
                      <Button
                        color="primary"
                        onClick={handleLoadMore}
                        disabled={
                          isFetchingSportRequests || !hasMoreSportRequests
                        }
                      >
                        {isFetchingSportRequests ? (
                          <Spinner size="sm" />
                        ) : (
                          "Load More"
                        )}
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>
            </Card>
          </>
        ) : (
          <Card className="filter-card mt-3">
            <CardBody className="bg-danger text-center rounded">
              <h2 className="text-white">
                <i className="fa fa-exclamation-triangle mr-3"></i> No Requests
                Submitted Yet.
              </h2>
            </CardBody>
          </Card>
        )}
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={modalPosition}>
        <ModalBody>
          <p className="auth-desc-subtitle mt-0 ml-0 pl-3 mb-0">
            Sport Details
          </p>
          {/* <Table className="align-items-center table-flush" responsive>
            <thead>
              <tr>
                <th scope="col" className="custom-table-heading custom-heading">
                  Sport Category
                </th>
                <th
                  scope="col"
                  className="custom-table-heading custom-heading text-center"
                >
                  Category Name
                </th>
              </tr>
            </thead>
            <tbody className="mt-3" style={{ background: "white" }}>
              {sportRequestsData.length > 0 &&
                data.map((ele, index) => (
                  <tr>
                    <td className={"custom-table-text"}>{ele.category}</td>
                    <td className="custom-table-text" align="center">
                      {ele.meaning}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table> */}

          <TableComponent
            columns={detailColumns}
            data={data}
            keyMap={detailKeyMap}
          />
          <div className="text-right">
            <Button
              className="mt-4"
              color="danger"
              onClick={handlePositionToggle}
            >
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={isModalOpen}>
        <ModalBody>
          {supporter && supporter.length > 0 ? (
            <TableComponent
              columns={supporterColumns}
              data={supporterData}
              keyMap={supporterKeyMap}
            />
          ) : (
            <Card className="filter-card mt-3">
              <CardBody className="bg-danger text-center rounded">
                <h3 className="text-white">
                  <i className="fa fa-exclamation-triangle mr-3"></i> No
                  Supporter Yet.
                </h3>
              </CardBody>
            </Card>
          )}
          <div className="text-right">
            <Button className="mt-4" color="danger" onClick={handleModal}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* <Modal isOpen={isModalOpen}>
        <ModalBody>
          <Table className="align-items-center table-flush" responsive>
            <thead>
              <tr>
                <th scope="col" className="custom-table-heading custom-heading">
                  Supporter Names
                </th>
              </tr>
            </thead>
            <tbody className="mt-3" style={{ background: "white" }}>
              {supporter && supporter.length > 0 ? (
                supporter.map((ele, index) => (
                  <tr>
                    <td className={"custom-table-text"}>
                      {getPlayerName(ele)}
                    </td>
                  </tr>
                ))
              ) : (
                <Card className="filter-card mt-3">
                  <CardBody className="bg-danger text-center rounded">
                    <h3 className="text-white">
                      <i className="fa fa-exclamation-triangle mr-3"></i> No
                      Supporter Yet.
                    </h3>
                  </CardBody>
                </Card>
              )}
            </tbody>
          </Table>
          <div className="text-right">
            <Button className="mt-4" color="danger" onClick={handleModal}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal> */}
      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={confirmModalOpen}
        toggle={() => setConfirmModalOpen(!confirmModalOpen)}
        onConfirm={handleConfirmAction}
        isLoading={confirmLoading}
        // title={confirmAction === "accept" ? "Accept Request" : "Reject Request"}
        message={
          confirmAction === "accept"
            ? "Are you sure you want to accept this sport request?"
            : "Are you sure you want to reject this sport request?"
        }
      />
    </>
  );
};

export default RequestedSports;
